export default "__VITE_ASSET__BqxFQKCL__"